<h4 class="content" markdown ngPreserveWhitespaces>{{ content }}</h4>
<rr-icon class="pointer" name="edit"></rr-icon>
